export default {
  filters: {
    today: "Aujourd'hui",
    yesterday: 'Hier',
    this_week: 'Cette semaine',
    last_week: 'Semaine dernière',
    this_month: 'Ce mois-ci',
    last_month: 'Mois dernier',
    all: 'Tout',
  },
};
